import React from "react";
import UserGenInfoAdmin from "../Forms/UserGenInfoAdmin";
import UserGenInfoTeacher from "../Forms/UserGenInfoTeacher";
import UserGenInfoStudent from "../Forms/UserGenInfoStudent";
import { useTranslation } from "react-i18next";

const AccountSettings = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language;
  const auth = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="container-fluid">
      <div className={`row ${isArabic === "sa" ? "flex-row-reverse" : ""}`}>
        {auth.user === "admin" ? (
          <UserGenInfoAdmin />
        ) : auth.user === "teacher" ? (
          <UserGenInfoTeacher />
        ) : auth.user === "student" ? (
          <UserGenInfoStudent />
        ) : null}
      </div>
    </div>
  );
};

export default AccountSettings;